"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.emailSelector = emailSelector;
exports.hasErrorSelector = hasErrorSelector;
exports.hasMerdgeErrorSelector = hasMerdgeErrorSelector;
exports.isSubmittingSelector = isSubmittingSelector;
exports.mergeErrorSelector = mergeErrorSelector;
exports.socialLoginIdSelector = socialLoginIdSelector;
exports.socialTypeSelector = socialTypeSelector;
var _social = require("../../types/social");
function hasErrorSelector(state) {
  const {
    authenticate
  } = state.authentication;
  const {
    merge
  } = state.social;
  return authenticate.status === _social.EAuthenticateStatus.Failed || merge.status === _social.EMergeStatus.Failed;
}
function isSubmittingSelector(state) {
  const {
    authenticate
  } = state.authentication;
  const {
    merge
  } = state.social;
  return authenticate.status === _social.EAuthenticateStatus.Loading || merge.status === _social.EMergeStatus.Loading;
}
function hasMerdgeErrorSelector(state) {
  const {
    merge
  } = state.social;
  const {
    authenticate
  } = state.authentication;
  return merge.status === _social.EMergeStatus.Failed || authenticate.status === _social.EAuthenticateStatus.Failed && merge.status === _social.EMergeStatus.Succeed;
}
function mergeErrorSelector(state) {
  if (!hasErrorSelector(state)) {
    return undefined;
  }
  const {
    merge
  } = state.social;
  const {
    authenticate
  } = state.authentication;
  return merge.status === _social.EMergeStatus.Failed ? merge.error : authenticate.error;
}
function socialTypeSelector(state) {
  return state.social.merge.socialType;
}
function socialLoginIdSelector(state) {
  return state.social.merge.socialLoginId;
}
function emailSelector(state) {
  return state.social.merge.email;
}